import React from "react";
import "./GiveReview.css";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Form } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";

const RatingStars = () => {
  return (
    <div className="star_widget">
      <input type="radio" name="rate" id="rate-5" />
      <label htmlFor="rate-5"></label>
      <input type="radio" name="rate" id="rate-4" />
      <label htmlFor="rate-4"></label>
      <input type="radio" name="rate" id="rate-3" />
      <label htmlFor="rate-3"></label>
      <input type="radio" name="rate" id="rate-2" />
      <label htmlFor="rate-2"></label>
      <input type="radio" name="rate" id="rate-1" />
      <label htmlFor="rate-1"></label>
    </div>
  );
};

const GiveReview = () => {
  const submitReview = () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const reviewData = document.getElementById("reviewMsg").value.trim();
    if (reviewData === "") {
      return alert("Why you give us a empty review");
    }
    const reviewDataForSubmit = { review: reviewData, star: 5 };

    axios
      .post("https://mysterious-sierra-48850.herokuapp.com/submit-review", reviewDataForSubmit, {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        if (data.data.success) {
          swal("", `${data.data.message}`, "success");
        }
      })
      .catch((err) => {
        console.log(err.response);
        swal("", `something went wrong`, "error");
      });
  };

  return (
    <div className="d-flex justify-content-center mt-5">
      <Card style={{ width: "100vh", maxWidth: "500px" }}>
        <Card.Title className="text-center mt-2">Review Now</Card.Title>
        <Card.Body>
          <Form>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="write review"
              id="reviewMsg"
            />
            <div className="d-flex justify-content-between align-items-center">
              <div className="starts mt-2">
                <FontAwesomeIcon icon={faStar} className="checked" />
                <FontAwesomeIcon icon={faStar} className="checked" />
                <FontAwesomeIcon icon={faStar} className="checked" />
                <FontAwesomeIcon icon={faStar} className="checked" />
                <FontAwesomeIcon icon={faStar} />
              </div>
              {/* <RatingStars/> */}
              <Button onClick={submitReview} className="mt-3">
                Submit Review
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GiveReview;
